/** Unknown amounts keep a group total unknown rather than understating it. */
export const sumDecimalAmounts = (values: readonly (string | null | undefined)[]): string | null => {
  if (!values.length || values.some((value) => value == null || !/^[+-]?\d+(?:\.\d+)?$/.test(value))) return null
  const amounts = values as readonly string[]
  const places = amounts.reduce((maximum, value) => Math.max(maximum, value.split('.')[1]?.length ?? 0), 0)
  const total = amounts.reduce((sum, value) => {
    const [integer, fraction = ''] = value.replace(/^[+-]/, '').split('.')
    const scaled = BigInt(integer + fraction.padEnd(places, '0'))
    return sum + (value.startsWith('-') ? -scaled : scaled)
  }, 0n)
  const digits = (total < 0n ? -total : total).toString().padStart(places + 1, '0')
  const fraction = places ? digits.slice(-places).replace(/0+$/, '') : ''
  const integer = places ? digits.slice(0, -places) : digits
  return `${total < 0n ? '-' : ''}${integer}${fraction ? `.${fraction}` : ''}`
}
